import { AppShell, Stack, Center } from "@mantine/core"
import { ReactElement } from "react"

import { IconProps } from "../../icons/icon.types"
import { NavBarItem } from "../../layout/NavBarItem/NavBarItem"

export type NavItem = {
  isActive?: boolean
  onClick: () => void
  label: string
  Icon: ({ hovered, ...props }: IconProps) => ReactElement
}

type Props = {
  logo?: ReactElement
  navItems: NavItem[]
  utilityItems?: NavItem[]
  footerContent?: ReactElement
}

export const AppNavBar = ({
  logo,
  navItems,
  utilityItems,
  footerContent,
}: Props) => {
  return (
    <AppShell.Navbar withBorder={false} bg="var(--sidebar-color)" pb="lg">
      <Stack h="100%" gap={0}>
        {/* Header Section - Logo */}
        <Stack flex={1} gap="xs" justify="space-between">
          {logo && (
            <Center w="100%" h="var(--navbar-item-height)">
              {logo}
            </Center>
          )}

          {/* Main Navigation - Primary links */}
          <Stack flex={1} gap="xs" justify="center">
            {navItems.map((item, index) => (
              <NavBarItem item={item} key={`${item.label}-${index}`} />
            ))}
          </Stack>
        </Stack>
        {/* Utility Navigation - Secondary/less important links */}
        {utilityItems && utilityItems.length > 0 && (
          <Stack
            gap="xs"
            py="md"
            style={{ borderTop: "1px solid var(--mantine-color-dark-4)" }}
          >
            {utilityItems.map((item, index) => (
              <NavBarItem item={item} key={`${item.label}-${index}`} />
            ))}
          </Stack>
        )}

        {/* Footer Section */}
        {footerContent && (
          <Stack style={{ borderTop: "1px solid var(--mantine-color-dark-4)" }}>
            {footerContent}
          </Stack>
        )}
      </Stack>
    </AppShell.Navbar>
  )
}
